import { motion } from 'framer-motion';
import Button from '@/components/Button';
import { classNames } from '@/utils/class-names';
import { Link } from 'react-router-dom';
import { useAdminStore } from '../../store/useAdmin.store';
import { useEffect } from 'react';
import { useResponsiveImage } from '@/utils/useResponsiveImage';

export const OnBoardingAdminStep1 = () => {
  const { page, onInit } = useAdminStore();

  useEffect(() => {
    if (!page) onInit();
  }, [onInit, page]);

  const title = page?.step1?.title || '';
  const description = page?.step1?.description || '';
  const buttonTxt = page?.step1?.buttonTxt || '';
  const { src } = useResponsiveImage(page?.step1?.image);

  if (title == '') {
    return null;
  }

  return (
    <div className="mt-sh-60 flex flex-col items-center justify-center px-4">
      <div className="flex gap-[10px]">
        {[1, 2, 3].map((_, index) => {
          return (
            <div
              className={classNames(
                ' flex size-[40px] items-center  justify-center rounded-full border border-primary-500',
                index !== 0 ? ' opacity-50' : ' bg-white',
              )}
              key={index}>
              <span className=" text-sh-xxxs font-bold">{index + 1}</span>
            </div>
          );
        })}
      </div>
      <div className="mt-20 flex flex-col items-center">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1.5 }}>
          <img src={src} alt="" width={430} height={287} className="mb-7 transition-all duration-300 ease-in" />
        </motion.div>

        <h1 className="mb-4 text-center text-sh-md font-bold">{'Welcome to the Admin Hub'}</h1>
        <div className="mb-8 w-1/2">
          <p className=" text-center text-sh-sm">{description}</p>
        </div>

        <Link to="/admin-on-boarding/step-2">
          <Button className="mb-28">{buttonTxt}</Button>
        </Link>
      </div>
    </div>
  );
};
